import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export interface TokenResponse {
  accessToken: string;
  refreshToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthDataSourceService {

  constructor(private httpClient: HttpClient) { }

  async getToken(user, pass, device, tenantId: string): Promise<TokenResponse> {
    const body = {
      username: user,
      password: pass,
      currentDevice: device
    };
    const headers = {
      'Content-Type': 'application/json',
      'tenant-id': tenantId
    };
    return this.httpClient.post(environment.baseUrl + '/api/v1/auth/token', body, { headers }).toPromise<any>();
  }

  refreshToken(refreshToken){
    const headers = {
      'Content-Type': 'application/json'
    };
    const body = {
      refreshToken
    };
    return this.httpClient.post(environment.baseUrl + '/api/v1/auth/refresh-token', body, { headers });
  }

  signOut(){
    const body = { currentDevice: "DESKTOP.ABC.WEB" };
    const headers = {
      'Content-Type': 'application/json',
    };
    return this.httpClient.put(environment.baseUrl + '/api/v1/auth/sign-out', body, { headers}).toPromise();
  }

}

